import { useMouseflowIdentify } from "../hooks/useMouseflowIdentityTracking";

const MouseflowIdentityTracking = () => {
  useMouseflowIdentify();
  return null;
};

export default MouseflowIdentityTracking;
